import React from 'react'
import BasePortableText from '@sanity/block-content-to-react'
import {getFluidGatsbyImage} from 'gatsby-source-sanity'
import Img from 'gatsby-image'

const clientConfig = {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'j4dvurzs',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
}



const Figure = ({node}) => {
    //  if (!node || !node.asset || !node.asset._id) { return null }
      const fluidProps = getFluidGatsbyImage(
        node.asset._ref,
        {maxWidth: 705},
        clientConfig
      )
      return (<>
          <Img fluid={fluidProps} alt={node.alt} />
          {node.caption && (
            <figcaption>{node.caption}</figcaption>
          )}
          
      </>)
    }  
  


const serializers = {
    types: {
  //    authorReference: ({node}) => <span>{node.author.name}</span>,
      image: Figure
    }
  }


const PortableText = ({blocks}) => { 

    return (
        <BasePortableText blocks={blocks} serializers={serializers} {...clientConfig.sanity} />
    )
}

export default PortableText
